import { FunctionComponent } from 'react'
import { Typography, Box } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'

interface ErrorTextProps {
  message?: string
}

export const ErrorText: FunctionComponent<ErrorTextProps> = ({ message }) => {
  const theme = useTheme()
  return (
    <Box>
      {message && (
        <Typography component="span"  variant="body1">
          <Box color={theme.colors.error}>{message}</Box>
        </Typography>
      )}
    </Box>
  )
}
